module.exports = __webpack_public_path__ + "img/onsen_even.f5eb0b89.svg";